// extracted by mini-css-extract-plugin
export var contentBody = "_bx-a";
export var headerImage = "_bx-2";
export var imageActions = "_bx-7";
export var imageButton = "_bx-8";
export var imageButtonIcon = "_bx-9";
export var imageHeader = "_bx-4";
export var imageHeaderText = "_bx-5";
export var imageOverlay = "_bx-3";
export var imageTitle = "_bx-6";
export var imageWrapper = "_bx-1";
export var taskList = "_bx-b";
export var widget = "_bx-0";